/** Stored goalType is i18n (en Habit / de Gewohnheit), not a stable enum. */
export function isHabitGoalType(goalType) {
  const normalized = String(goalType ?? '').trim().toLowerCase();
  return normalized === 'habit' || normalized === 'gewohnheit';
}

const WEEKDAY_CODES = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];

function weekdayCodeFromDay(day) {
  if (typeof day === 'string') {
    return String(day).trim().toUpperCase();
  }
  const raw = day?.rSchName ?? day?.name ?? day?.day ?? '';
  return String(raw).trim().toUpperCase();
}

/**
 * Always returns the 7 weekday chips with stable rSchName codes.
 * Accepts stored reminderTime.days and/or WEEKLY repeatRules.byDayOfWeek.
 */
export function normalizeReminderDays(rawDays, repeatRules) {
  const selected = new Set();

  for (const day of rawDays ?? []) {
    const code = weekdayCodeFromDay(day);
    if (!WEEKDAY_CODES.includes(code)) continue;
    if (typeof day === 'string' || day?.isSelected === true) {
      selected.add(code);
    }
  }

  // If stored days lost rSchName (only isSelected flags), fall back to WEEKLY rules.
  if (selected.size === 0) {
    for (const rule of repeatRules ?? []) {
      if (String(rule?.frequency ?? '').toUpperCase() !== 'WEEKLY') continue;
      for (const d of rule.byDayOfWeek ?? []) {
        const code = String(d).trim().toUpperCase();
        if (WEEKDAY_CODES.includes(code)) selected.add(code);
      }
    }
  }

  // Last resort: 7-length array without codes → treat by weekday order.
  if (
    selected.size === 0
    && Array.isArray(rawDays)
    && rawDays.length === WEEKDAY_CODES.length
  ) {
    rawDays.forEach((day, index) => {
      if (day?.isSelected === true) selected.add(WEEKDAY_CODES[index]);
    });
  }

  return WEEKDAY_CODES.map((rSchName) => ({
    rSchName,
    isSelected: selected.has(rSchName),
  }));
}
